import { render } from "./BlockOpportunity.vue?vue&type=template&id=96ce8e00&scoped=true"
import script from "./BlockOpportunity.vue?vue&type=script&lang=js"
export * from "./BlockOpportunity.vue?vue&type=script&lang=js"

import "./BlockOpportunity.vue?vue&type=style&index=0&id=96ce8e00&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ce8e00"]])

export default __exports__